<template>
    <section class="c-significance">
        <div class="c-significance__content">
            <div class="significance-content">
                <div
                    v-if="content.title"
                    class="significance-content__title"
                >
                    <h2
                        class="content-title"
                        v-text="content.title"
                    />
                </div>
                <div
                    v-if="content.text"
                    class="significance-content__list"
                >
                    <div v-html="content.text" />
                </div>
                <div
                    v-if="content.custom"
                    class="significance-content__action"
                >
                    <y-button
                        :disabled="disableCtaBtn"
                        :tag="checkTagName()"
                        :href="content.custom['button-link']"
                        :to="content.custom['button-link']"
                        :content="content.custom['button-title']"
                        color="primary"
                        size="medium"
                        flat
                        :no-padding="true"
                    />
                </div>
            </div>
        </div>
        <div
            v-if="(isDesktop || hasImageInMobile) && content.image"
            class="c-significance__image-container"
        >
            <img
                :src="imgSrc(content.image)"
                :alt="content.title"
                class="significance-img"
                :height="$mq === 'md' || $mq === 'lg' || $mq === 'xlg' ? 467 : 330"
                :width="$mq === 'md' || $mq === 'lg' || $mq === 'xlg' ? 467 : 330"
            >
        </div>
    </section>
</template>

<script >
    import { isLink } from '@/helpers/helpers';

    export default {
        name      : 'Significance',
        components: {
        },

        props: {
            content: {
                type    : Object,
                required: true,
            },
            hasImageInMobile: Boolean,
            disableCtaBtn   : Boolean,
        },

        computed: {
            /**
             * Device is desktop or not
             *
             * @returns {boolean}
             */
            isDesktop() {
                return this.$mq === 'lg' || this.$mq === 'xlg';
            },
        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            isLink,

            /**
             *
             * check tag name
             *
             * @returns {string}
             */
            checkTagName() {
                if (this.disableCtaBtn) {
                    return 'button';
                }
                return isLink(this.content.custom['button-link']) ? 'a' : 'router-link';
            },
        },
    };

</script>

<style lang="scss" src="./significance.scss"/>
